import React from 'react'
import ApiTrafficStatusBadge from '../Badges/StatusBadges'

export function ApiTrafficLogsTable ({ logs, loading, onView }) {
  return (
    <div className="table-responsive position-relative">
      {loading && (
        <div
          className="d-flex position-absolute top-0 start-0 w-100 h-100 align-items-center justify-content-center bg-opacity-75"
          style={{ zIndex: 5 }}
        >
          <div className="spinner-border text-primary" role="status" />
        </div>
      )}

      <table className="table table-hover align-middle">
        <thead>
          <tr>
            <th>Tanggal</th>
            <th>Dari</th>
            <th>Ke Endpoint</th>
            <th>External ID</th>
            <th>TrxID</th>
            <th>Request ID</th>
            <th>Status</th>
            <th style={{ width: 140 }}>Detail</th>
          </tr>
        </thead>
        <tbody>
          {logs.length
            ? (
                logs.map((el) => (
              <tr key={el.id}>
                <td>{el.date}</td>
                <td>{el.from}</td>
                <td>
                  <code>{el.endpoint}</code>
                </td>
                <td>{el.x_external_id || '-'}</td>
                <td>{el.trx_id || '-'}</td>
                <td>{el.payment_request_id || '-'}</td>
                <td>
                  <ApiTrafficStatusBadge status={el.status} />
                </td>
                <td>
                  <button onClick={() => onView(el.id)} className="btn btn-sm btn-primary" title="View">
                    <i className="fa-solid fa-search" />
                  </button>
                </td>
              </tr>
                ))
              )
            : (
            <tr>
              <td colSpan={5} className="text-center text-muted py-5">
                <i className="fa-solid fa-inbox fa-2x mb-2 d-block" />
                No logs found for the selected filters.
              </td>
            </tr>
              )}
        </tbody>
      </table>
    </div>
  )
}

export default ApiTrafficLogsTable
